<template>
  <div>
    <nav-header
      ref="navHeader"
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showNavbar="p_showNavbar"
      v-bind:showCart="p_showCart"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
    <nav-bread></nav-bread>
    <div class="main_wrap">
      <img class="banner banner-phone" src="../assets/about_banner_mobile.png" alt="">
      <img class="banner banner-pc" src="../assets/about_banner_pc.png" alt="">
      <div class="content">
        <h1>检验网简介</h1>
        <p>
          检验网是专业提供医学检验服务的互联网平台，运用强大前沿的互联网技术，为个人用户、医学检验所、和医疗机构提供一站式医检服务解决方案。
          检验网<router-link to="/">jianyanwang.com</router-link>，一点联通，轻松医检。
        </p>

        <h2>For 个人用户</h2>
        <ul>
          <li>
            手机端/公众号/小程序直接下单、自采样、支付，不受地域限制享受检验服务
          </li>
          <li>
            无须医院排队/挂号，提前获得专业医检服务，信息私密
          </li>
          <li>
            异地线上线下采样，在线获取报告
          </li>
        </ul>

        <h2>For 医学检验所</h2>
        <ul>
          <li>
            共享海量个人检测需求，提升业务量
          </li>
          <li>
            多种营销工具，形成客户裂变
          </li>
          <li>
            极简操作，高效精准，自动生成报告，样本到报告全程管理
          </li>
          <li>
            支持三级分销，检验所、代理商、经销商
          </li>
          <li>
            私域独立商城和小程序，打造自有粉丝池
          </li>
        </ul>

        <h2>For 医疗机构</h2>
        <ul>
          <li>
            扩大检测范围，提升检测能力与品牌影响力
          </li>
          <li>
            采样、送检、线上报告，全程实时监控，与第三方检测深度合作
          </li>
          <li>
            提高病患诊治效率，提高诊治容量
          </li>
        </ul>
      </div>
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
  import axios from 'axios'
  import "./../assets/css/base.css";
  import "@/assets/css/product.css";
  import "@/assets/css/index.css?version=1.0.1";
  import NavHeader from "@/components/Header.vue";
  import NavFooter from "@/components/Footer.vue";
  import NavBread from "@/components/Bread.vue";
  import {getCookie} from "@/util/util.js"
  import 'babel-polyfill'

  export default {
    name: "AboutUs",
    data() {
      return {
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showNavbar: true,
        p_showCart: true
      };
    },
    components: {
      NavHeader,
      NavFooter,
      NavBread
    },
    computed: {

    },
    mounted: function () {

    },
    methods: {
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },
      p_closeLoginModal() {
        this.p_loginModalFlag = false
      }
    },

    watch: {

    }
  };
</script>
<style scoped>
.main_wrap {
  width: 45%;
  margin: 0 auto;
}
.content {
  margin: 0 auto;
  padding: 50px 0;
}

.content p {
  font-size: 15px;
  line-height: 25px;
  text-indent: 30px;
}

.banner-phone {
  display: none;
}

.banner-pc{
  display: block;
  width: 100%;
}

.about_img {
  width: 100%;
  height: auto;
  margin-top: 40px;
}

li {
  list-style: initial;
  text-indent: 20px;
  line-height: 25px;
  color: gray;
}

h1 {
  width: 50%;
  padding-left: 10px;
  border-left: 6px solid #00c5b0;
  font-size: 16px;
  font-weight: bolder;
  margin-bottom: 20px;
}

h2 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: bolder;
}


</style>

<style scoped>
  @media only screen and (max-width: 600px) {
    .main_wrap {
      width: 100%;
      font-size: 13px;
    }
    .banner-phone{
      display: block;
      width: 100%;
    }
    .banner-pc{
      display: none;
    }

    .content {
      width: 85%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue